var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMyWealthHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0507 17.9795C22.7847 17.9796 25.8114 21.0072 25.8114 24.7412V24.8457C25.8112 26.6223 24.3712 28.0623 22.5946 28.0625H9.40027C7.62345 28.0625 6.18268 26.6225 6.1825 24.8457V24.7412C6.1825 21.0073 9.20934 17.9798 12.9432 17.9795H19.0507ZM16.1864 4C19.5141 4.00011 22.1862 6.67155 22.1864 9.99902C22.1864 13.3278 19.5143 15.9999 16.1864 16C12.8584 16 10.1864 13.3279 10.1864 9.99902C10.1866 6.67148 12.8586 4 16.1864 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMyWealthHover);
export default __webpack_public_path__ + "static/media/manage-my-wealth-hover.2494491724a18ef82b74024fed5227e2.svg";
export { ForwardRef as ReactComponent };